import { SyllabusResponse } from '@api/gateway/KnowledgePreexam-default/index'
import { Page } from './../../management/common/models/Page'
import {
  DimensionPropertyResponse,
  SyllabusMataResponse,
  SyllabusQueryRequest,
  SyllabusResponsePage
} from './../../../gateway/KnowledgePreexam-default/index'
import KnowledgePreexamGateway from '@api/gateway/KnowledgePreexam-default'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Response, { ResponseStatus } from '@api/Response'
import store from '@/store'
import Syllabus from '@api/module/common/syllabus/model/Syllabus'
import SyllabusMata from '@api/module/common/syllabus/model/SyllabusMata'
import { cloneDeep } from 'lodash'
import SyllabusTreeMata from './model/SyllabusTreeMata'
import Vue from 'vue'

interface MapX<K extends string, V> {
  key: K
  value: V
}

/**
 * 考纲数据状态
 */
export interface SyllabusState {
  /**
   *@description //考纲树信息缓存-详情用-只保存顶级考纲树信息
   *@author lsh
   *@param
   *@date 2020-12-04
   */
  syllabusList: Array<Syllabus>

  /**
   * 考纲树Map-考纲id-考纲id下的所有考纲元素集合-考纲-考纲元素关联使用
   */
  syllabusMap: Record<string, Array<SyllabusMata>>

  initLoad: boolean
}

/**
 * 定义公共的考纲模块
 */
@Module({ namespaced: true, dynamic: true, name: 'SyllabusModuleDecorator', store })
class SyllabusModuleDecorator extends VuexModule implements SyllabusState {
  //region state
  /**
   *@description //考纲树信息缓存-详情用-只保存顶级考纲树信息
   *@author lsh
   *@param
   *@date 2020-12-04
   */
  syllabusList: Array<Syllabus> = new Array(0)
  /**
   *@description //考纲节点信息缓存-查路径-详情用
   *@author lsh
   *@param
   *@date 2020-12-04
   */
  syllabusMataObject: Record<string, SyllabusMata> = {}

  /**
  /**
   * 考纲树Map-考纲id-考纲id下的所有考纲元素集合-考纲-考纲元素关联使用
   */
  syllabusMap: Record<string, Array<SyllabusMata>> = {}

  initLoad = false
  //endregion

  // region Actions
  /**
   *@description 初始化考纲树信息-初始化某一类别下的考纲信息
   *@author lsh
   *@date 2020-12-07
   */
  @Action
  public async initSyllabusList(query: SyllabusQueryRequest): Promise<ResponseStatus> {
    if (this.initLoad) return Promise.resolve(new ResponseStatus(500, '初始化中请勿重复调用'))
    this.SET_LOAD(true)
    const syllabusList = new Array(0)
    let totalSize = 200,
      pageNo = 1
    while (syllabusList.length < totalSize) {
      const result = await KnowledgePreexamGateway.findSyllabusPageListByQuery({
        query,
        pageNo: pageNo++,
        pageSize: totalSize
      })
      syllabusList.push(...result.data.currentPageData)
      totalSize = result.data.totalSize
      if (!result.status.isSuccess()) return result.status
    }
    this.SET_SYLLABUS_LIST(syllabusList)
    this.SET_LOAD(false)
    return Promise.resolve(new ResponseStatus(200, 'success'))
  }
  /**
   *@description 重载标志位
   *@author lsh
   *@param
   *@date 2020-12-17
   */
  reload = false
  /**
   *@description 考纲树缓存
   *@author lsh
   *@param
   *@date 2020-12-23
   */
  syllabusTreeObject = {}
  /**
   *@description 获取整棵树的所有元素节点
   *@author lsh
   *@param syllabusId 考纲树Id reload:是否需要重载
   *@date 2020-12-08
   */
  @Action
  public async initChapterList(params: { syllabusId: string; reload?: boolean }): Promise<ResponseStatus> {
    //没有该考纲信息 并且 标志位为true 走加载
    if (this.syllabusMap[params.syllabusId] && !params.reload && !this.reload) {
      return Promise.resolve(new ResponseStatus(200, ''))
    }

    const syllabusArr: Array<SyllabusMata> = new Array(0)
    let totalSize = 200,
      pageNo = 1
    while (syllabusArr.length < totalSize) {
      const resultpageMataBySyllabus = await KnowledgePreexamGateway.pageMataBySyllabus({
        page: {
          pageNo: pageNo++,
          pageSize: 200
        },
        syllabusId: params.syllabusId
      })
      totalSize = resultpageMataBySyllabus.data.totalSize
      resultpageMataBySyllabus.data.currentPageData.forEach(syllabusMata => {
        const { name, id, syllabusId, parentId, weights, importance, path, childList } = syllabusMata
        syllabusArr.push({ name, id, syllabusId, parentId, weights, importance, path, childList })
      })
      if (!resultpageMataBySyllabus.status.isSuccess()) {
        return resultpageMataBySyllabus.status
      }
    }

    this.SET_RELOAD(false)
    this.SET_SYLLABUS_TREE({ syllabusId: params.syllabusId, syllabTree: syllabusArr })
    //组装树
    const mataList = cloneDeep(this.syllabusMap[params.syllabusId])
    //搜索所有父节点为0的节点
    const roodIds = new Array(0)
    mataList?.forEach((node, index) => {
      if (node.parentId == '0') roodIds.push(index)
    })
    const nodeHeap = new Array(0),
      syllabTree = new Array(0)
    for (const value of roodIds) {
      //树的顶级节点 因为强制转换代码量很大 写成这样转换 实际的转换在下面做
      const syllabTreeNode = mataList[value] as any
      //把所有的父节点推入树变量
      syllabTree.push(syllabTreeNode)
      //父节点的子节点全部推入队列
      nodeHeap.push(...syllabTreeNode.childList)
      syllabTreeNode.isLeaf = !syllabTreeNode.childList.length
    }

    while (nodeHeap.length) {
      let syllabusMeta = nodeHeap.shift()
      //搜索子节点
      const nodeIndex = mataList.findIndex(node => node.id === syllabusMeta?.nodeId)
      syllabusMeta = Object.assign(syllabusMeta, mataList[nodeIndex])
      //删除无用的属性
      delete syllabusMeta.nodeId
      delete syllabusMeta.type
      //弹出已经搜索的降低后续搜索复杂度
      nodeHeap.push(...mataList.splice(nodeIndex, 1)[0]?.childList)
      //缓存元素信息
    }

    const dfsGetWeight = (treeNode: SyllabusTreeMata) => {
      treeNode.showWeights = treeNode.weights
      for (const child of treeNode.childList) {
        treeNode.showWeights += dfsGetWeight(child)
      }
      return treeNode.showWeights
    }
    for (const tree of syllabTree) {
      dfsGetWeight(tree)
    }
    this.SET_SYLLABUS_TREE_OBJECT({ syllabusId: params.syllabusId, tree: syllabTree })

    return Promise.resolve(new ResponseStatus(200, ''))
  }

  @Mutation
  SET_SYLLABUS_TREE_OBJECT(payload: { syllabusId: string; tree: any }) {
    Vue.set(this.syllabusTreeObject, payload.syllabusId, payload.tree)
  }
  /**
   *@description 获取考纲信息-整棵树
   *@author lsh
   *@param syllabusId -- 考纲树id
   *@date 2020-12-03
   */
  get syllabusTree() {
    return (syllabusId: string): Array<SyllabusTreeMata> => {
      return this.syllabusTreeObject[syllabusId] || []
    }
  }
  /**
   *@description 分页获取考纲树的数据
   *@author lsh
   *@param Query 类型 SyllabusQueryRequest
   *@param Page 可选 分页的data里的currentPageData实际返回 Syllabus 类型
   *@date 2020-12-03
   */
  @Action
  async findSyllabusListPage(params: {
    query: SyllabusQueryRequest
    page?: Page
  }): Promise<Response<SyllabusResponsePage>> {
    const result = await KnowledgePreexamGateway.findSyllabusPageListByQuery({
      query: params.query,
      pageNo: params.page?.pageNo || 1,
      pageSize: params.page?.pageSize || 200
    })
    this.SET_SYLLABUS_LIST(result.data.currentPageData)
    for (const SyllabusRootNode of result.data.currentPageData) {
      const yearList = new Array(0),
        yearIdList = new Array(0)
      SyllabusRootNode.yearList.forEach((year: DimensionPropertyResponse) => {
        yearList.push(year.propertyName)
        yearIdList.push(year.propertyId)
      })
      const regionList = new Array(0),
        regionIdList = new Array(0)
      SyllabusRootNode.regionList.forEach((region: DimensionPropertyResponse) => {
        regionList.push(region.propertyName)
        regionIdList.push(region.propertyId)
      })
      Object.assign(SyllabusRootNode, { yearList, yearIdList, regionList, regionIdList })
    }
    return result
  }

  /**
   *@description 分页获取考纲元素的数据
   *@author lsh
   *@param syllabusMataIdList 类型 考纲元素id
   *@date 2020-12-03
   */
  @Action
  async findSyllabusMataListPage(syllabusMataIdList: Array<string>): Promise<Response<Array<SyllabusMataResponse>>> {
    const result = await KnowledgePreexamGateway.findSyllabusMataList(syllabusMataIdList)
    for (const SyllabusMataNode of result.data) {
      const { name, id, syllabusId, parentId, weights, importance, path, childList } = SyllabusMataNode
      this.SET_SYLLABUS_MATA_OBJECT({
        syllabusId: SyllabusMataNode.id,
        SyllabusMataNode: { name, id, syllabusId, parentId, weights, importance, path, childList }
      })
    }
    return result
  }

  /**
   * 根据考纲元素id批量获取考纲路径名称
   * @param syllabusMataIdList
   */
  @Action
  async findSyllabusMataPathNameList(syllabusMataIdList: Array<string>): Promise<Response<Map<string, string>>> {
    const response = new Response<Map<string, string>>()
    const syllabusMataResponse = await this.findSyllabusMataListPage(syllabusMataIdList)
    if (!syllabusMataResponse.status) {
      response.status = syllabusMataResponse.status
      return response
    }

    const allSyllabusMataIdList = syllabusMataResponse.data.flatMap(r => r.path.split('/')).filter(r => r)
    const allSyllabusMataResponse = await this.findSyllabusMataListPage(allSyllabusMataIdList)
    if (!allSyllabusMataResponse.status) {
      response.status = allSyllabusMataResponse.status
      return response
    }

    const map = new Map<string, string>()
    for (const syllabusMata of syllabusMataResponse.data) {
      const namePath = syllabusMata.path
        .split('/')
        .map(s => allSyllabusMataResponse.data.find(a => a.id === s)?.name || '')
        .join('/')
      map.set(syllabusMata.id, namePath)
    }
    response.data = map
    response.status = allSyllabusMataResponse.status
    return response
  }
  //endregion

  //region muataion
  //设置考纲树加载
  @Mutation
  private SET_LOAD(initLoad: boolean) {
    this.initLoad = initLoad
  }

  //设置考纲树
  @Mutation
  SET_SYLLABUS_LIST(list: Array<SyllabusResponse>) {
    list.forEach(params => {
      const { id, name, weightsLevel, major } = params
      const yearList = new Array(0),
        yearIdList = new Array(0)
      params.yearList.forEach((year: DimensionPropertyResponse) => {
        yearList.push(year.propertyName)
        yearIdList.push(year.propertyId)
      })
      const regionList = new Array(0),
        regionIdList = new Array(0)
      params.regionList.forEach((region: DimensionPropertyResponse) => {
        regionList.push(region.propertyName)
        regionIdList.push(region.propertyId)
      })
      const syllabusEle = { id, name, weightsLevel, major, yearList, yearIdList, regionList, regionIdList }
      const idx = this.syllabusList.findIndex(item => item.id === params.id)
      if (idx > -1) {
        this.syllabusList[idx] = syllabusEle
      } else {
        this.syllabusList.push(syllabusEle)
      }
    })
  }

  /**
   *@description 设置考纲元素基础信息
   *@author lsh
   *@param
   *@date 2020-12-08
   */
  @Mutation
  SET_SYLLABUS_MATA_OBJECT(playLoad: { syllabusId: string; SyllabusMataNode: SyllabusMata }) {
    this.syllabusMataObject[playLoad.syllabusId] = playLoad.SyllabusMataNode
  }

  //设置考纲树加载
  @Mutation
  protected SET_RELOAD(reload: boolean) {
    this.reload = reload
  }

  //设置考纲-考纲元素关联信息-设置成数组方便使用数组的操作
  @Mutation
  SET_SYLLABUS_TREE(playLoad: { syllabusId: string; syllabTree: Array<SyllabusMata> }) {
    Vue.set(this.syllabusMap, playLoad.syllabusId, playLoad.syllabTree)
  }

  //endregion

  //region get

  /**
   *@description 根据-专业id查询对应考纲
   *@author lsh
   *@param syllabusMajorId 数组 or string
   *@date 2020-12-07
   */
  get getSyllabusByMajorId() {
    return (syllabusMajorId: string | Array<string>) => {
      if (Array.isArray(syllabusMajorId)) {
        const arr: Array<Syllabus> = []
        syllabusMajorId.forEach(majorId => {
          arr.push(...this.syllabusList.filter(item => item.major.id === majorId))
        })
        return arr
      } else {
        return this.syllabusList.filter(item => item.major.id === syllabusMajorId)
      }
    }
  }

  /**
   *@description 返回考纲
   *@author lsh
   *@param
   *@date 2020-12-07
   */
  get syllabusObject() {
    const obj = {}
    this.syllabusList.forEach(item => (obj[item.id] = item))
    return obj
  }

  /**
   *@description 获取考纲元素列表-整棵树
   *@author lsh
   *@param syllabusId -- 考纲树id
   *@date 2020-12-03
   */
  get getSyllabusMataList() {
    return (syllabusId: string): Array<SyllabusMata> => {
      return this.syllabusMap[syllabusId]
    }
  }
  /**
   *@description 获取所有至选取节点以下的元素节点
   *@author lsh
   *@param syllabusId 考纲id
   *@param syllabusMataId 考纲元素id
   *@date 2020-12-04
   */
  get getSyllabusTreeFromSelectNode() {
    return (syllabusId: string, syllabusMataId: string) => {
      const bfsSearchNode = () => {
        const tree = this.syllabusTree(syllabusId),
          syllabusMataHeap = [...tree]
        let selectNode
        while (syllabusMataHeap.length) {
          selectNode = syllabusMataHeap.shift()
          if (selectNode?.id === syllabusMataId) return selectNode
          for (const child of selectNode?.childList || []) {
            syllabusMataHeap.push(child)
          }
        }
        return null
      }
      return bfsSearchNode()
    }
  }
  /**
   *@description 获取所有至选取节点以下的 考纲节点id
   *@author lsh
   *@param syllabusId 考纲id
   *@param syllabusMataId 考纲元素id
   *@date 2020-12-04
   */
  get getSyllabusIdsFromSelectNode() {
    return (syllabusId: string, syllabusMataId: string) => {
      const bfsPushId = () => {
        const ids = [],
          selectNode = this.getSyllabusTreeFromSelectNode(syllabusId, syllabusMataId)
        const syllabusMataHeap = [selectNode]
        if (!selectNode) return []
        while (syllabusMataHeap.length) {
          const selectNode = syllabusMataHeap.shift()
          if (selectNode) ids.push(selectNode?.id)
          for (const child of selectNode?.childList || []) {
            syllabusMataHeap.push(child)
          }
        }
        return ids
      }
      return bfsPushId()
    }
  }
  // endregion
}

export default SyllabusModuleDecorator
